import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  confirmDelete,
  ErrorMsg,
  GetFormData,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../Util/common";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { KendoMultiSelect } from "../../Kendo/kendo_multiselect";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../Util/axios_core_helper";
import { useDispatch, useSelector } from "react-redux";
import { onDisplayedInEdit, SaveServicesSlice } from "./VenueHighlightsSlice";
import { KendoLoader } from "../../Kendo/kendo_loader";
import { toast } from "react-toastify";

export const VenueHighlights = () => {
  const [VenueHighlights, setVenueHighlights] = useState({
    VenueHighlightsID: 0,
    VenueHighlightsType: "",
    DisplayedInID: "",
    displayedInName: "",
    Title: "",
    Description: "",
    Image: "",
    OldimagePath: "",
    SortOrder: 0,
  });
  const [refreshflag, setrefreshflag] = useState(0);

  const [editVisible, setEditVisible] = useState(false);
  const [error, setError] = useState({});
  const modalRef = useRef(null);
  const { selDisplayedInIds } = useSelector((state) => state.VenueHighlights);
  const dispatch = useDispatch();
  const [Loading, setLoading] = useState(false);

  const clearForm = () => {
    $("#hide").click();
    setLoading(false);
    setVenueHighlights({
      VenueHighlightsID: 0,
      VenueHighlightsType: "",
      DisplayedInID: "",
      displayedInName: "",
      Title: "",
      Description: "",
      Image: "",
      OldimagePath: "",
      SortOrder: 0,
    });
    setError({});
    setEditVisible(false);
    dispatch(onDisplayedInEdit(""));
    const form = document.getElementById("form-culture-config");
    if (form) {
      form.reset();
    }
  };
  const handleDateChange = (e) => {
    const selectedDate = e ? e : null;
    if (selectedDate == null) {
      setVenueHighlights((prevEvents) => ({
        ...prevEvents,
        EventDate: null,
      }));
    } else {
      setVenueHighlights((prevEvents) => ({
        ...prevEvents,
        EventDate: selectedDate,
      }));
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;
    let oversize = false;
    oversize = VenueHighlights.Image?.size > maxSizeInBytes;

    const err = ValidateForm(e);
    if (err) {
      setError(err);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: oversize,
      }));
    } else if (!oversize) {
      setLoading(true);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
      }));
      const formData = new FormData();
      var data = GetFormData(e);
      if (editVisible && editVisible.visible) {
        data.CultureId = editVisible.cultureId;
      }

      formData.append("VenueHighlightsID", VenueHighlights.VenueHighlightsID);
      formData.append(
        "VenueHighlightsType",
        VenueHighlights.VenueHighlightsType
      );
      formData.append("DisplayedInID", VenueHighlights.DisplayedInID);
      formData.append("Title", VenueHighlights.Title);
      formData.append("Description", VenueHighlights.Description);
      formData.append("OldimagePath", VenueHighlights.OldimagePath);
      formData.append("SavedBy", sessionUser());
      if (VenueHighlights.Image) {
        formData.append("Image", VenueHighlights.Image);
      }

      try {
        await corepost(
          "VenueHighlights/InsertUpdateVenueHighlights",
          formData,
          true,
          true,
          false,
          false
        );
        setrefreshflag(refreshflag + 1);
        clearForm();
        $("#VenueHighlights-cancel").click();
      } catch (error) {
        console.error("Error while submitting the form:", error);
      }
    } else {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: true,
      }));
    }
  };

  const handleEditClick = async (e) => {
    let temp = VenueHighlights;
    dispatch(onDisplayedInEdit(e.displayedInID));
    VenueHighlights.VenueHighlightsID = e.venueHighlightsID;
    VenueHighlights.VenueHighlightsType = e.venueHighlightsType;
    VenueHighlights.DisplayedInID = e.displayedInID;
    VenueHighlights.Title = e.title;
    VenueHighlights.Description = e.description;
    VenueHighlights.Image = e.imagePath;
    VenueHighlights.OldimagePath = e.imagePath;
    setVenueHighlights(temp);
    setEditVisible(true);

    const modal = new bootstrap.Modal(
      document.getElementById("add_VenueHighlights")
    );
    modal.show();
  };

  const handleDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `VenueHighlights/DeleteVenueHighlights?venueHighlightsID=${e.venueHighlightsID}`,
        true,
        false,
        true
      ).then(() => {
        setrefreshflag((prev) => prev + 1);
      });
    };
    confirmDelete(onDelete);
  };
  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };
  const onRowReorderChange = async (List) => {
    try {
      let VenueHighlightsID = $(List.newRow).find("td").eq(0).text();
      let oldSortId = $(List.newRow).find("td").eq(1).text();
      let newSortId = $(List.oldRow).find("td").eq(1).text();
      await corefetch(
        `VenueHighlights/SortVenueHighlights?TypeId=${VenueHighlightsID}&newSortId=${newSortId}&oldSortId=${oldSortId}`
      );
      setrefreshflag(refreshflag + 1);
    } catch (error) {
      console.error("Error during row reorder:", error);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const hasAvifFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (hasAvifFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (!file) {
      // No file selected
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
        ValidFile: false,
      }));
      setVenueHighlights((prev) => ({
        ...prev,
        Image: "",
      }));
      onValidation("Image", e.target.value);
      return;
    }

    if (file && file.type.startsWith("image/")) {
      // Valid image file
      setError({ ...error, ValidFile: false });

      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        InValidFileSize: isFileTooLarge,
      }));

      if (isFileTooLarge) {
        // If the file is too big
        setVenueHighlights((prev) => ({
          ...prev,
          Image: file,
        }));
      } else {
        // File size is okay
        let temp = VenueHighlights;
        temp.Image = file;
        setVenueHighlights(temp);

        const reader = new FileReader();
        reader.onloadend = () => {
          setVenueHighlights((prev) => ({
            ...prev,
            previewUrl: reader.result,
          }));
        };
        reader.readAsDataURL(file);

        document.getElementById("image-name").value = file.name;
      }

      onValidation("Image", e.target.value);
    } else {
      // Invalid file type
      e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        InValidFileSize: false,
      }));
      setVenueHighlights((prev) => ({
        ...prev,
        Image: "",
      }));
    }
  };

  const handleDropdownChange = (e) => {
    const seletedValue = e ? e : null;
    setVenueHighlights((prevEvents) => ({
      ...prevEvents,
      DisplayedInID: seletedValue,
    }));
  };

  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Venue Highlights</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <li>Configuration</li>
              </li>
              <li className="breadcrumb-item active">Venue Highlights</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  <Button
                    name={"Add"}
                    dataBsToggle={"modal"}
                    dataBsTarget={"#add_VenueHighlights"}
                    dataBsDismiss={"modal"}
                  />
                </div>
              </div>
            </div>

            <div>
              <i>
                <span style={{ backgroundColor: "yellow", fontWeight: "bold" }}>
                  Note:
                </span>{" "}
                This module supports drag-and-drop functionality. You can easily
                rearrange or move data as needed.
              </i>
              <KendoGrid
                name={"VenueHighlightsGrid"}
                url={CorebaseURL + "VenueHighlights/GetVenueHighlightsDetails"}
                schema={{}}
                columns={[
                  {
                    field: "venueHighlightsID",
                    filterable: false,
                    hidden: true,
                  },
                  { field: "sortOrder", hidden: true },
                  {
                    field: "displayedInID",
                    filterable: false,
                    hidden: true,
                  },

                  {
                    field: "venueHighlightsType",
                    title: "Venue Highlights Type",
                    width: 150,
                  },

                  {
                    field: "displayedInName",
                    title: "Displayed In",
                    width: 150,
                  },
                  {
                    field: "title",
                    hidden: true,
                  },
                  {
                    field: "description",
                    title: "Description",
                    template: function (e) {
                      const maxLength = 50; // Set max length for display
                      return e.description.length > maxLength
                        ? `${e.description.substring(0, maxLength)}...`
                        : e.description;
                    },
                    width: 200, // Adjust the width as needed
                  },

                  {
                    // Template for displaying images with fixed size
                    template: function (e) {
                      if (e.imagePath) {
                        return `<img src="${ImageURL}${e.imagePath}" width="40px" height="40px" />`;
                      }
                      return "";
                    },
                    title: "Image",
                    width: 60,
                  },
                ]}
                showOptions={true}
                showEdit={true}
                showDelete={true}
                onEditClick={handleEditClick}
                onDeleteClick={handleDeleteClick}
                disableExportExcel={true}
                enableRowReorderable={true}
                onRowReorder={onRowReorderChange}
                refreshWhen={refreshflag}
                height={"60vh"}
              />
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add VenueHighlights Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_VenueHighlights"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered VenueHighlights"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{editVisible ? "Edit" : "Add"}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-culture-config" onSubmit={onSubmit}>
                <input
                  type="hidden"
                  name="ID"
                  value={VenueHighlights.VenueHighlightsID || 0}
                />

                {/* Single Column Layout */}
                <div className="row">
                  <div className="col-12 mb-3">
                    <div className="input-block">
                      <label className="form-label">
                        Venue Highlights Type{" "}
                        <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Venue Highlights Type with a maximum length of 30 characters." />
                      </label>
                      <input
                        type="text"
                        maxLength={30}
                        className="form-control field"
                        name="VenueHighlightsType"
                        value={VenueHighlights.VenueHighlightsType || ""}
                        placeholder="Venue Highlights Type"
                        data-required="true"
                        onChange={(e) => {
                          setVenueHighlights((prev) => ({
                            ...prev,
                            VenueHighlightsType: e.target.value,
                          }));
                          onValidation("VenueHighlightsType", e.target.value); // Real-time validation
                        }}
                      />
                      {error.VenueHighlightsType && (
                        <ErrorMsg text="Venue Highlights Type is required" />
                      )}
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <div className="input-block">
                      <label className="form-label">
                        Displayed In <span className="text-danger">*</span>
                      </label>
                      <KendoMultiSelect
                        name="DisplayedInID"
                        url={CorebaseURL + "VenueHighlights/GetDisplayesInList"}
                        placeholder={"Select Displayed In..."}
                        dataTextField="eventName"
                        dataValueField="displayedInID"
                        value={selDisplayedInIds}
                        required={true}
                        onValidate={onValidation}
                        onChange={handleDropdownChange}
                        tagMode="multiple"
                      />
                      {error.DisplayedInID && (
                        <ErrorMsg text="Displayed In is required" />
                      )}
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <div className="input-block">
                      <label className="form-label">
                        Description <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a description with a maximum length of 1000 characters." />
                      </label>
                      <textarea
                        maxLength={1000}
                        className="form-control field"
                        name="Description"
                        value={VenueHighlights.Description}
                        placeholder="Description"
                        data-required="true"
                        onChange={(e) => {
                          setVenueHighlights((prev) => ({
                            ...prev,
                            Description: e.target.value,
                          }));
                          onValidation("Description", e.target.value);
                        }}
                      />
                      {error.Description && (
                        <ErrorMsg text="Description is required" />
                      )}
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    <div className="input-block mb-3">
                      <label className="form-label">
                        Upload Image <span className="text-danger">*</span>
                        <InfoIcon
                          content="
                           Ensure the image size does not exceed 500KB.;
                          The recommended dimensions are 230px width by 350px height for the best viewing experience;
                           Please upload the image in JPEG,JPG or PNG format."
                        />
                      </label>
                      <input
                        className="form-control"
                        type="file"
                        name="file"
                        accept="image/*"
                        onChange={handleFileChange}
                      />
                      {error.Image && <ErrorMsg text=" Image is required" />}
                      {error.ValidFile && (
                        <ErrorMsg text="please upload Image file only" />
                      )}
                      {error.InValidFileSize && (
                        <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
                      )}
                    </div>
                  </div>

                  <div className="col-12 mb-3">
                    {VenueHighlights.OldimagePath &&
                      VenueHighlights.VenueHighlightsID > 0 && (
                        <div
                          style={{
                            width: "100%",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          <a
                            href={`${ImageURL}${VenueHighlights.OldimagePath}`}
                            target="_blank"
                            style={{
                              textDecoration: "underline",
                              fontSize: "13px",
                            }}
                          >
                            {VenueHighlights.OldimagePath.split("/").pop()}
                          </a>
                        </div>
                      )}
                    <input
                      type="hidden"
                      name="Image"
                      id="image-name"
                      data-required="true"
                      value={VenueHighlights.Image || ""}
                    />
                    <input
                      type="hidden"
                      name="OldimagePath"
                      value={VenueHighlights.OldimagePath}
                    />
                  </div>
                </div>
                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="VenueHighlights-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearForm();
                      }}
                    />
                    <Button name={editVisible ? "Update" : "Save"} />
                  </div>
                )}
                <button
                  type="button"
                  id="hide"
                  style={{ display: "none" }}
                  data-bs-dismiss={"modal"}
                  onClick={() => {
                    clearForm();
                  }}
                ></button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* <!-- /Add VenueHighlights Modal --> */}
    </>
  );
};
